import React from 'react';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import {
  CricketGenRules,
  T20MatchRules,
  CricketCheeting,
  TestMachRules,
  RulesOfTennis,
  RulesOfSoccer,
  RulesOfBinary,
} from '../../constants/SportRules';
import './MarketTermsCondi.scss';

type MarketTermsProps = {
  oddsType?: string;
  eventTypeID: string;
};

const MarketTermsCondi: React.FC<MarketTermsProps> = (props) => {
  const { eventTypeID } = props;

  return (
    <div className="odds-terms-condi-ctn">
      {eventTypeID === '4' ? (
        <>
          {CricketGenRules.map((r, index) => (
            <Accordion className="rules-accordion">
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography>{r.category?.toLocaleLowerCase()}</Typography>
              </AccordionSummary>
              <AccordionDetails>
                {r.rules.map((r, index) => (
                  <p className="conditions-paragraph">
                    {index + 1}. {r}
                  </p>
                ))}
              </AccordionDetails>
            </Accordion>
          ))}

          <Accordion className="rules-accordion">
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography>T20/ODI Rules</Typography>
            </AccordionSummary>
            <AccordionDetails>
              {T20MatchRules.map((r, index) => (
                <>
                  <div className="sub-header">
                    {index + 1} {r.category}
                  </div>
                  {r.rules.map((ru, idx) => (
                    <p>
                      {index}.{idx + 1}. {ru}
                    </p>
                  ))}
                </>
              ))}
            </AccordionDetails>
          </Accordion>

          <Accordion className="rules-accordion">
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography>Test Match</Typography>
            </AccordionSummary>
            <AccordionDetails>
              {TestMachRules.map((r, index) => (
                <>
                  <div className="sub-header">
                    {index + 1} {r.category}
                  </div>
                  {r.rules.map((ru, idx) => (
                    <p>
                      {index}. {idx + 1}. {ru}
                    </p>
                  ))}
                </>
              ))}
            </AccordionDetails>
          </Accordion>

          {CricketCheeting.map((r, index) => (
            <Accordion className="rules-accordion">
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography>{r.category}</Typography>
              </AccordionSummary>
              <AccordionDetails>
                {r.rules.map((r, index) => (
                  <Typography>
                    <>
                      {r.split('.').map((a, b) => (
                        <p>
                          {b == 0 ? <>{index + 1}. </> : null}
                          {a}.
                        </p>
                      ))}
                    </>
                  </Typography>
                ))}
              </AccordionDetails>
            </Accordion>
          ))}
        </>
      ) : null}

      {eventTypeID === '2' ? (
        <>
          {RulesOfTennis.map((r, index) => (
            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography>{r.category}</Typography>
              </AccordionSummary>
              <AccordionDetails>
                {r.rules.map((r, index) => (
                  <p>
                    {index + 1}. {r}
                  </p>
                ))}
              </AccordionDetails>
            </Accordion>
          ))}
        </>
      ) : null}

      {eventTypeID === '1' ? (
        <>
          {RulesOfSoccer.map((r, index) => (
            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography>{r.category}</Typography>
              </AccordionSummary>
              <AccordionDetails>
                {r.rules.map((r, index) => (
                  <p>
                    {index + 1}. {r}
                  </p>
                ))}
              </AccordionDetails>
            </Accordion>
          ))}
        </>
      ) : null}

      {eventTypeID === 'Binary' ? (
        <>
          {RulesOfBinary.map((r, index) => (
            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography>{r.category}</Typography>
              </AccordionSummary>
              <AccordionDetails>
                {r.rules.map((r, index) => (
                  <p>
                    {index + 1}. {r}
                  </p>
                ))}
              </AccordionDetails>
            </Accordion>
          ))}
        </>
      ) : null}
    </div>
  );
};

export default MarketTermsCondi;
